export const selectGridInstance = state => state.grid.gridInstance;
export const selectGridStateId = state => state.grid.gridStateName;
